import { writable } from 'svelte/store'

let defaultValue = {}

let persistant = window.localStorage.getItem('persistant_flags')
defaultValue = persistant ? JSON.parse(persistant) : defaultValue

function createPersistantStore() {
    const { subscribe, set, update } = writable(defaultValue)
    const persistValue = (val) =>
        window.localStorage.setItem('persistant_flags', JSON.stringify(val))
    return {
        subscribe,
        reset: () => set(defaultValue),
        get value() {
            let ret
            subscribe(r => ret = r)
            return ret
        },
        add(name, value) {
            return update((dataStore) => {
                let ret = Object.fromEntries([
                    ...Object.entries(dataStore),
                    [name, value],
                ])
                persistValue(ret)
                return ret
            })
        },
        update(name, value) {
            // @ts-ignore
            return update((dataStore) => {
                if(name in dataStore) { 
                    let ret = Object.fromEntries(
                        Object.entries(dataStore)
                        .map(([k, v]) => [k, k == name ? value : v])
                    )
                    persistValue(ret)
                    return ret
                } else {
                    this.add(name, value)
                    return this.value
                }
            })
        },
        delete(name) {
            // @ts-ignore
            return update((dataStore) => {
                if(name in dataStore) { 
                    let ret = Object.fromEntries(
                        Object.entries(dataStore)
                        .filter(([k]) => k !== name)
                    )
                    persistValue(ret)
                    return ret
                } else {
                    return false
                }
            })
        },
    }
}

const persistant_flags = createPersistantStore()
export default persistant_flags
